// Action Type
export const SELECTED_PACKS = "SELECTED_PACKS";

export const selectPackage = config => {
  return {
      type: SELECTED_PACKS,
      payload: config
  }
}